import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m6.65 4.24.09.087 20 22a1 1 0 0 1-1.39 1.433l-.09-.087L21.013 23H17v7a1 1 0 0 1-1.993.117L15 30v-7H5a1 1 0 0 1-.117-1.993L5 21h1.161L8.279 8.993 5.26 5.673A1 1 0 0 1 6.65 4.24m3.33 6.624L8.191 21h11.004zM25 5a1 1 0 0 0-1-1H11.406l-.117.007A1 1 0 0 0 11.406 6h9.755l2.406 13.635.027.113a1 1 0 0 0 1.943-.461L23.19 6H24l.117-.007A1 1 0 0 0 25 5"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconPushPinSimpleSlash = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconPushPinSimpleSlash);
export default Memo;
